module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs2":"classnames","commonjs":"classnames","amd":"classnames","umd":"classnames","root":"_"}
// module id = 3
// module chunks = 0 1 2 3 4 5